/**
 * @generated SignedSource<<d590cda0735e4e64e0c263551911d454>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamNavigatorQuery$variables = {
  employeeId?: string | null;
  id?: string | null;
};
export type TeamNavigatorQuery$data = {
  readonly home: {
    readonly " $fragmentSpreads": FragmentRefs<"TeamNavigatorNoTeam_home" | "TeamNavigator_home">;
  } | null;
  readonly store: {
    readonly publicTeams: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"TeamNavigator_team">;
    }>;
    readonly team: {
      readonly " $fragmentSpreads": FragmentRefs<"TeamNavigator_team">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"TeamNavigatorNoTeam_store" | "TeamNavigator_store">;
  };
  readonly storeViewer: {
    readonly " $fragmentSpreads": FragmentRefs<"TeamNavigator_storeViewer">;
  };
};
export type TeamNavigatorQuery = {
  response: TeamNavigatorQuery$data;
  variables: TeamNavigatorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "employeeId",
    "variableName": "employeeId"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "includeArchived",
    "value": false
  }
],
v4 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "TeamNavigator_team"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = [
  (v7/*: any*/),
  (v8/*: any*/)
],
v10 = [
  (v7/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPublicAndInternalImage"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicImageUrl",
          "storageKey": null
        }
      ],
      "type": "PublicImage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbhash",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "sizes",
          "plural": true,
          "selections": [
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlExpiresAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Image",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workStatus",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "EmployeeRole",
  "kind": "LinkedField",
  "name": "roles",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employeeCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employees",
      "plural": true,
      "selections": [
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isLinkedToViewer",
          "storageKey": null
        },
        (v15/*: any*/),
        (v14/*: any*/),
        (v8/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canEdit",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": {
      "throwOnFieldError": true
    },
    "name": "TeamNavigatorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "home",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TeamNavigator_home"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TeamNavigatorNoTeam_home"
          }
        ],
        "storageKey": null
      },
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": "StoreViewer",
          "kind": "LinkedField",
          "name": "storeViewer",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TeamNavigator_storeViewer"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TeamNavigator_store"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TeamNavigatorNoTeam_store"
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": (v4/*: any*/),
            "storageKey": "publicTeams(includeArchived:false)"
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamNavigatorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "home",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isHomeUnion"
          },
          {
            "kind": "InlineFragment",
            "selections": (v9/*: any*/),
            "type": "Organisation",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v10/*: any*/),
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StoreViewer",
        "kind": "LinkedField",
        "name": "storeViewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignedCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "teams",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": (v2/*: any*/),
                "kind": "ScalarField",
                "name": "todoActiveAssignedCount",
                "storageKey": null
              },
              (v8/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "myRole",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "employeeId"
              }
            ],
            "concreteType": "Employee",
            "kind": "LinkedField",
            "name": "currentEmployee",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v8/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreUser",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "myPermissions",
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customizations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Dashboard",
            "kind": "LinkedField",
            "name": "dashboards",
            "plural": true,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v7/*: any*/),
              (v16/*: any*/),
              (v11/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v18/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v16/*: any*/),
              (v11/*: any*/),
              (v17/*: any*/)
            ],
            "storageKey": "publicTeams(includeArchived:false)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "04bf8cb5c08a61706b6b4811d07a8337",
    "id": null,
    "metadata": {},
    "name": "TeamNavigatorQuery",
    "operationKind": "query",
    "text": "query TeamNavigatorQuery(\n  $id: ID\n  $employeeId: ID\n) {\n  home {\n    __typename\n    ...TeamNavigator_home\n    ...TeamNavigatorNoTeam_home\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on Organisation {\n      id\n    }\n  }\n  storeViewer(employeeId: $employeeId) {\n    ...TeamNavigator_storeViewer\n    id\n  }\n  store {\n    ...TeamNavigator_store\n    ...TeamNavigatorNoTeam_store\n    publicTeams(includeArchived: false) {\n      ...TeamNavigator_team\n      id\n    }\n    team(id: $id) {\n      ...TeamNavigator_team\n      id\n    }\n    id\n  }\n}\n\nfragment Avatar_employee on Employee {\n  image {\n    __typename\n    ...ImagePublicOrPrivate_image\n    ... on Image {\n      id\n    }\n  }\n  workStatus\n  name\n}\n\nfragment Avatar_user on User {\n  name\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment StorecastPickerPopoverDashboards on Dashboard {\n  id\n  ...StorecastPickerPopoverItem_dashboard\n}\n\nfragment StorecastPickerPopoverItem_dashboard on Dashboard {\n  id\n  name\n}\n\nfragment TeamHeaderAssignedBadge_storeViewer on StoreViewer {\n  assignedCount\n}\n\nfragment TeamHeaderProfileButton_employee on Employee {\n  ...Avatar_employee\n}\n\nfragment TeamHeaderProfileButton_storeUser on StoreUser {\n  user {\n    ...Avatar_user\n    id\n  }\n}\n\nfragment TeamHeaderRoles_team on Team {\n  id\n  roles {\n    id\n    name\n    employeeCount\n    employees {\n      id\n      isLinkedToViewer\n      workStatus\n      ...Avatar_employee\n    }\n  }\n}\n\nfragment TeamHeader_home on HomeUnion {\n  __isHomeUnion: __typename\n  ... on Organisation {\n    __typename\n    id\n    name\n  }\n}\n\nfragment TeamHeader_store on Store {\n  ...TeamPickerPopover_store\n  myRole\n  name\n  customizations\n  ...TeamSettingsPopover_Store\n  currentEmployee(id: $employeeId) {\n    id\n    ...TeamHeaderProfileButton_employee\n  }\n  me {\n    ...TeamHeaderProfileButton_storeUser\n    id\n  }\n  dashboards {\n    ...StorecastPickerPopoverDashboards\n    id\n  }\n}\n\nfragment TeamHeader_storeViewer on StoreViewer {\n  ...TeamHeaderAssignedBadge_storeViewer\n  ...TeamPickerPopover_storeViewer\n}\n\nfragment TeamHeader_team on Team {\n  ...TeamPickerButton_team\n  ...TeamHeaderRoles_team\n  id\n  name\n  color\n  canEdit\n  ...TeamSettingsPopover_Team\n}\n\nfragment TeamHomeNavigator_home on HomeUnion {\n  __isHomeUnion: __typename\n  ...TeamHeader_home\n}\n\nfragment TeamHomeNavigator_store on Store {\n  ...TeamScheduleHeader_store\n  ...TeamHeader_store\n  team(id: $id) {\n    ...TeamHeader_team\n    ...TeamScheduleHeader_team\n    id\n  }\n}\n\nfragment TeamHomeNavigator_storeViewer on StoreViewer {\n  ...TeamHeader_storeViewer\n}\n\nfragment TeamNavigatorNoTeam_home on HomeUnion {\n  __isHomeUnion: __typename\n  ... on Store {\n    __typename\n  }\n  ... on Organisation {\n    __typename\n    id\n    name\n  }\n}\n\nfragment TeamNavigatorNoTeam_store on Store {\n  myRole\n  currentEmployee(id: $employeeId) {\n    ...TeamHeaderProfileButton_employee\n    id\n  }\n  me {\n    ...TeamHeaderProfileButton_storeUser\n    id\n  }\n}\n\nfragment TeamNavigator_home on HomeUnion {\n  __isHomeUnion: __typename\n  ...TeamHeader_home\n  ...TeamHomeNavigator_home\n  __typename\n}\n\nfragment TeamNavigator_store on Store {\n  id\n  myRole\n  ...TeamPickerPopover_store\n  ...TeamHomeNavigator_store\n  ...TeamHeader_store\n}\n\nfragment TeamNavigator_storeViewer on StoreViewer {\n  ...TeamHeader_storeViewer\n  ...TeamHomeNavigator_storeViewer\n}\n\nfragment TeamNavigator_team on Team {\n  id\n  name\n  type\n  ...TeamHeader_team\n}\n\nfragment TeamPickerButton_team on Team {\n  name\n  icon\n  isPrivate\n}\n\nfragment TeamPickerPopoverItem_team on Team {\n  id\n  name\n  color\n  icon\n  isPrivate\n}\n\nfragment TeamPickerPopover_store on Store {\n  currentEmployee(id: $employeeId) {\n    ...Avatar_employee\n    id\n  }\n  me {\n    teams {\n      id\n    }\n    user {\n      ...Avatar_user\n      id\n    }\n    id\n  }\n}\n\nfragment TeamPickerPopover_storeViewer on StoreViewer {\n  teams {\n    id\n    todoActiveAssignedCount(employeeId: $employeeId)\n    ...TeamPickerPopoverItem_team\n  }\n}\n\nfragment TeamScheduleHeader_store on Store {\n  ...usePermissions_store\n}\n\nfragment TeamScheduleHeader_team on Team {\n  id\n  name\n  color\n}\n\nfragment TeamSettingsPopover_Store on Store {\n  id\n  name\n}\n\nfragment TeamSettingsPopover_Team on Team {\n  id\n  name\n  icon\n  color\n  isPrivate\n}\n\nfragment usePermissions_store on Store {\n  id\n  myPermissions\n}\n"
  }
};
})();

(node as any).hash = "b36a249796890ac0cfba995137404758";

export default node;
